<template>
  <div align="center" class="container-fluid">
    <page-header></page-header>
    <table width="98%" border="0" cellpadding="0" cellspacing="0" class="table_green" bgcolor="#e7f3d6">
      <tbody>
        <tr>
          <td width="10" height="25">&nbsp;</td>
          <td width="100%" align="left" valign="middle"><img src="../assets/img/jt.jpg" width="9" height="9">{{$t('currlocation')}}:{{$t('welcom')}} </td>
        </tr>
      </tbody>
    </table>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <div align="center" style="min-height: 350px;">
      <table width="80%" border="0" cellpadding="0" cellspacing="0" class="table_blue">
        <!--DWLayoutTable-->
        <tr>
          <td width="100%" height="98" align="center" valign="middle" style="font-weight: bold;font-size:14px ">
            {{$t('welcom')}}
          </td>
        </tr>
      </table>
    </div>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
export default {
  components: { PageHeader, PageFooter },
  mounted () {
    //强制刷新,elementUI组件切换中英文不生效的问题
    // if (location.href.indexOf("login") == -1) {
    //   console.log('进来了9998')
    //   location.href = location.href + "#login";
    //   location.reload();
    // }
    if (window.performance.navigation.type == 1) {
      //  console.log("页面被刷新")
    } else {
      location.reload();
    }
    // location.reload();
  }
  // computed: {
  //   isEnglish () {
  //     console.log(this.$store.state.lang)
  //     return this.$store.state.lang;　　//需要监听的数据
  //   }
  // },
  // watch: {
  //   isEnglish: {
  //     handler: function (newVal) {
  //       window.localtion.reload();
  //     }
  //   },
  // }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/index.css";
</style>
PageFooter